
$(document).ready(function() {
    const $slideshow = $('.hero-slideshow');
    const $proxyLinks = $slideshow.find('[data-link-proxy]');

    if($proxyLinks.length){
        $proxyLinks.off('click'); // Removing previous proxy link initialization

        $slideshow.on('init', slick => {
            $proxyLinks.ProxyLink({
                excludes: ['.slick-dots']
              });
        });
    }

    // ANIMATE FIRST SLIDE ON INITALIZATION
    $slideshow.on('init', slick => {
        window.setTimeout(function() {
            $slideshow.addClass('slick-animations-ready');
        }, 300);
    });

    $slideshow.slick({
        dots: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 600,
        autoplay: true,
        centerMode: true,
        centerPadding: '610px',
       
        responsive: [
            {
                breakpoint: 1840,
                settings: {
                    centerPadding: '580px',
                }
            },
            {
                breakpoint: 1700,
                settings: {
                    centerPadding: '450px',
                }
            },
            {
                breakpoint: 1300,
                settings: {
                    centerPadding: '300px',
                }
            },
            {
                breakpoint: 900,
                settings: {
                    centerPadding: '250px',
                }
            },
            {
                breakpoint: 780,
                settings: {
                    centerPadding: '200px',
                }
            },
            {
                breakpoint: 767,
                settings: {
                    centerMode: false,
                    centerPadding: '32px',
                }
            }
        ]
    });

    $('.slick-slide').each(function() {
        var $backgorundColor = $(this).find('.hero__slide').attr('data-background');

        $('.slideshow__section .hero-slideshow__wrapper').css('background-color', $backgorundColor);
    });

    $slideshow.on('beforeChange', function(event, slick, currentSlide, nextSlide){
        // section background color
        var $nextBackgorundColor = $('.slick-active + .slick-slide').find('.hero__slide').attr('data-background');
        $('.slideshow__section .hero-slideshow__wrapper').css('background-color', $nextBackgorundColor);
    });
});
